import { render, staticRenderFns } from "./LeaveType.vue?vue&type=template&id=a55f962c&scoped=true"
import script from "./LeaveType.vue?vue&type=script&lang=js"
export * from "./LeaveType.vue?vue&type=script&lang=js"
import style0 from "./LeaveType.vue?vue&type=style&index=0&id=a55f962c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55f962c",
  null
  
)

export default component.exports